import { MultiWordTreeBuilder } from "../../General/Tree/MultiSet/multi-word-tree-builder";
import { MultiSetTreeNode } from "../../General/Tree/MultiSet/multi-set-tree-node";
import { Node } from "../../General/graph/lib/node";
import { SubTreeWords } from "./sub-tree-words";
import { ContentChild } from "@angular/core";

export class TreeWords extends MultiWordTreeBuilder {
    private subNode: MultiSetTreeNode;
    subGraph: SubTreeWords;
    subGraphMode: boolean = false;
    subNodeMode: boolean = false;
    hideContentMode: boolean = false;
    cachedHiddenContent: any[][] = [];

    hideRandomNodes(count: number) {
        while (count > 0) {
            let index: number = Math.floor(Math.random() * this.nodes.length);
            let node: Node = this.nodes[index];
            if (node instanceof MultiSetTreeNode) {
                node.setHidden(true);
            }
            count = count - 1;
        }
    }

    showSolution() {
        this.cachedHiddenContent = this.getHiddenNodes();
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                node.setHidden(false);
            }
        })
        if (this.subGraphMode) {
            if (this.subGraph != null) {
                this.subGraph.getNodes().forEach(node => {
                    if (node instanceof MultiSetTreeNode) {
                        node.setHidden(false);
                    }
                })
            }
        }
        this.update();
    }

    generateSimplePaths(targetContent?: string) {
        let nodesToDelete: Node[] = [];
        for (let i = 0; i < this.nodes.length; i++) {
            let node: Node = this.nodes[i];
            if (node instanceof MultiSetTreeNode) {
                let content: any[] = node.getContent();
                let isSimple: boolean = true;
                for (let x = 0; x < content.length; x++) {
                    for (let y = x + 1; y < content.length; y++) {
                        if (content[x] == content[y]) {
                            isSimple = false;
                            break;
                        }
                    }
                  /*  if(content[x] == targetContent &&  x < content.length-1){
                        isSimple = false;
                        break;
                    }*/
                }
                if (!isSimple)
                    nodesToDelete.push(node);
            }

        }

        nodesToDelete.forEach(node => {
            this.deleteNode(node);
        })

        if (this.nodes.length > 1) {
            let newRoot: Node = this.nodes[1];
            if (newRoot instanceof MultiSetTreeNode) {
                this.setSubNode(newRoot.getContent());
            }
        }
        this.update();
    }
    deleteNode(delNode: Node) {
        if (delNode == null)
            return;

        let childrenToRemove: Node[] = [delNode];
        while (childrenToRemove.length > 0) {
            let parent: Node = childrenToRemove.shift();
            parent.getNeighbors().forEach(neighbor => {
                childrenToRemove.push(neighbor);
            });
            if (parent instanceof MultiSetTreeNode) {
                super.deleteNode(parent);
            }
        }
        this.update();
    }

    hideSolution() {
        this.setHiddenNodes(this.cachedHiddenContent);
        if (this.subGraphMode) {
            if (this.subGraph != null) {
                this.subGraph.setHiddenNodes(this.cachedHiddenContent);
            }
        }
        this.update();
    }


    setSubNode(subNodeContent: any[]) {
        if (subNodeContent.length == 0) {
            return;
        }

        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (this.equalContent(node.getContent(), subNodeContent)) {
                    this.subNode = node;
                    this.subGraphMode = true;
                    this.subGraph = new SubTreeWords(this.subNode, this.canvas, this.getDepthNode(this.subNode));
                    this.subGraph.enable();
                    this.subGraph.buildTree();
                    this.subGraph.setHiddenNodes(this.getHiddenNodes());
                    this.subGraph.update();
                    this.update();

                    return;
                }
            }
        })

    }

    getDepthNode(node: Node): number{
        if(node.getNeighbors().length == 0){
            return 1;
        }
        let maxDepth = -1;
        for(let i = 0; i < node.getNeighbors().length; i++){
            let neighbor: Node = node.getNeighbors()[i];
            let myDepth = this.getDepthNode(neighbor)+1;
            if(myDepth > maxDepth){
                maxDepth = myDepth;
            }
        }
        return maxDepth;
    }

    setHiddenNodes(content: any[][]) {
        content.forEach(c => {
            this.nodes.forEach(node => {
                if (node instanceof MultiSetTreeNode) {
                    if (this.equalContent(node.getContent(), c)) {
                        node.setHidden(true);
                    }
                }
            })
        })
    }

    getHiddenNodes(): any[][] {
        let content: any[][] = [];
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (node.isHidden()) {
                    content.push(node.getContent());
                }
            }
        })
        if (this.subGraph != null) {
            this.subGraph.getHiddenNodes().forEach(c => {
                let contained: boolean = false;
                content.forEach(c1 => {
                    if (this.equalContent(c1, c)) {
                        contained = true;
                    }
                })
                if (!contained) {
                    content.push(c);
                }


            })
        }

        return content;
    }

    getSubNode(): MultiSetTreeNode {
        if (!this.subGraphMode)
            return null;
        if (this.subGraph != null) {
            if (this.subGraph.getRoot() != null) {
                return this.subGraph.getRoot();
            }
        }

        return this.subNode;
    }

    setSubTreeMode() {
        this.subNodeMode = true;
        if (this.subGraph != null) {
            this.subGraph.subNodeMode = true;
        }
        this.hideContentMode = false;
    }

    setHideNodeMode() {
        if (this.subGraphMode) {
            if (this.subGraph != null) {
                this.subGraph.hideContentMode = true;
            }
        } else {
            this.hideContentMode = true;
        }
        this.subNodeMode = false;
        if (this.subGraph != null) {
            this.subGraph.subNodeMode = false;
        }
    }

    setGraphMode() {
        this.subGraphMode = false;
        if (this.subGraph != null) {
            this.subGraph.disable();
        }
        this.subNodeMode = false;
        this.hideContentMode = false;
        if (this.subGraph != null) {
            if (this.subGraph instanceof SubTreeWords) {
                this.setHiddenNodes(this.subGraph.getHiddenNodes());
            }
        }

    }

    doubleClick() {
        return;
    }

    leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        let clickedNode: MultiSetTreeNode = null;
        //If in subgraphmode ignore leftclick
        if (this.subGraphMode)
            return;

        this.nodes.forEach(n => {
            if (n.inParameter(e, this.grid)) {
                if (n instanceof MultiSetTreeNode) {
                    clickedNode = n;
                }
            }
        })
        if (this.subNodeMode) {
            if (this.root == clickedNode || clickedNode == null) {
                return;
            }
            this.subNode = clickedNode;
            this.subGraph = new SubTreeWords(this.subNode, this.canvas);
            //  console.log("SUBNODE : " + this.subNode.getContent());
            this.subGraph.enable();
            this.subGraphMode = true;
            this.subGraph.buildTree();
            this.subGraph.setHiddenNodes(this.getHiddenNodes());
        }
        if (this.hideContentMode) {
            this.subNodeMode = false;
            this.hideContentMode = false;
            clickedNode.setHidden(!clickedNode.isHidden());
        }
        this.update();
    }

    update() {
        if (this.subGraphMode && this.subGraph != null) {
            //console.log("Draw subgraph");
            this.subGraph.update();
        }
        else {
            super.update();
        }
    }

    keyboardEvent() {
        return;
    }
    rightClick() {
        return;
    }
    equalContent(content1: any[], content2: any[]): boolean {
        if (content1 == null || content2 == null) {
            return false;
        }
        if (content1.length != content2.length) {
            return false;
        }

        for (let i = 0; i < content1.length; i++) {
            if (!(content1[i] == content2[i])) {
                return false;
            }
        }
        return true;
    }
}
